<!-- <template>
  <div class="" dir="rtl">
    <div class="vh-100 w-100 mx-0 show">
      <div
        style=""
        class="p-0 h-100 text-white w-sidebar sidebar collapse show"
      >
        <Sidebar />
      </div>
      <div class="main-container col px-0">
        <Navbar />
        <div class="row justify-content-center mx-0">
          <div class="col-md-11 px-0">
            <main class="main px-0 px-md-4 pt-3">
              <slot name="mainView"></slot>
            </main>
            <div class="text-center mt-4 text-sm mb-5 pb-5">
              <div class="copyright">
                جميع الحقوق محفوظة &copy; {{ new Date().getFullYear() }}
              </div>
              <div class="text-muted">
                Provided by <span class="text-white-50">Digital Plus Technology Co. Ltd</span>
              </div>
            </div>
          </div>
        </div>
        <BottomNavigation />
      </div>
    </div>

    Modals 
    <PlayedTrackInfo /> 
    <PlayedTracklist />
  </div>
</template> -->

<!-- <script>
// import PlayedTrackInfo from '../../components/Player/PlayedTrackInfo.vue';
import PlayedTracklist from '../../components/Player/PlayedTracklist.vue';
import BottomNavigation from "./BottomNavigation.vue";
import Navbar from "./Navbar.vue";
import Sidebar from "./Sidebar.vue";

export default {
  components: {
    BottomNavigation,
    Navbar,
    Sidebar,
    // PlayedTrackInfo,
    PlayedTracklist,
  },
};
</script> -->

<!-- <style lang="scss">
@use "../../assets/css/mdb.rtl.min";
@use "../../assets/css/custom";
</style> -->

<template>
  <div class="app-wrapper" dir="rtl">
    <NewNavbar />

    <div class="content-body">
      <aside class="sidebar-wrapper d-none d-md-block">
        <NewSidebar />
      </aside>

      <main class="main-content-area">
        <div class="container-fluid pt-4">
          <slot name="mainView"></slot>

          <footer class="text-center mt-5 mb-5 pb-5">
            <p class="copyright">
              جميع الحقوق محفوظة &copy; {{ new Date().getFullYear() }}
            </p>
            <small class="text-muted"
              >Provided by Digital Plus Technology Co. Ltd</small
            >
          </footer>
        </div>
      </main>
    </div>

    <BottomNavigation />
    <PlayedTracklist />
  </div>
</template>


<script>
// import PlayedTrackInfo from '../../components/Player/PlayedTrackInfo.vue';
import PlayedTracklist from "../../components/Player/PlayedTracklist.vue";
import BottomNavigation from "./BottomNavigation.vue";
import NewSidebar from "./NewSidebar.vue";
import NewNavbar from "./NewNavbar.vue";

export default {
  components: {
    BottomNavigation,
    NewNavbar,
    NewSidebar,
    // PlayedTrackInfo,
    PlayedTracklist,
  },
};
</script>

<style lang="scss">
@use "../../assets/css/mdb.rtl.min";
@use "../../assets/css/custom";
@use "../../assets/css/base-variables";
</style>

<style scoped>
.app-wrapper {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
}

.content-body {
  display: flex;
  flex: 1;
  overflow: hidden;
}

.sidebar-wrapper {
  width: 260px;
  height: 100%;
  overflow-y: auto;
}

.main-content-area {
  flex: 1;
  overflow-y: auto;
  background-color: #1a1a1a;
}

@media (max-width: 768px) {
  .sidebar-wrapper {
    display: none;
  }
}
</style>
